import { useEffect } from 'react';
import { Button, Card, Col, Row } from 'react-bootstrap';
import './PromptAuthorization.scss';
import { withCookies }  from 'react-cookie';
import UserAnalytic, { TRACKING_STATUS } from '../../helpers/UserAnalytic';
import languageManager from '../../helpers/Language';


const MainCard = ({
    onDecision
}) => {
    return (
        <div className="PromptAuthorizationComponent animate-pauthc p-4">
            <Card className="h-100 shadow-sm">
                <Card.Body className="p-3 py-2">
                    <div className="fs-4 fw-normal mb-2 text-uppercase">{languageManager.T('PROMPT_AUTHRZ_COOKIE_TITLE')}</div>
                    <p className="mb-3 fw-light">
                        {languageManager.T('PROMPT_AUTHRZ_COOKIE_TEXT')}
                    </p>
                    <Row>
                        <Col xs={12} sm={6} className="mb-2">
                            <Button
                                onClick={() => onDecision(TRACKING_STATUS.YES)}
                                variant="primary"
                                className="w-100 fw-bold">{languageManager.T('PROMPT_AUTHRZ_COOKIE_BTN_AGREE')}</Button>
                        </Col>
                        <Col xs={12} sm={6} className="mb-2">
                            <Button
                                onClick={() => onDecision(TRACKING_STATUS.NO)}
                                variant="light"
                                className="w-100 border">{languageManager.T('PROMPT_AUTHRZ_COOKIE_BTN_DECLINE')}</Button>
                        </Col>
                        {/* <Col xs={12} className="mb-0">
                            <Button variant="link" className="w-100">Set my preferences</Button>
                        </Col> */}
                    </Row>
                </Card.Body>
            </Card>
        </div>
    );
}

export const PromptAuthorization = ({
    cookies
}) => {
    const handleDecision = (cookieStatus) => {
        UserAnalytic.setTrackingStatus(cookieStatus);
    };
    return (
        <MainCard onDecision={handleDecision}/>
    );
};

export default withCookies(PromptAuthorization);